import { Component } from "react";
import { verifyPaddleActivationToken } from "../../ajax/cloud";
import { withTranslation } from "react-i18next";
import debug from "src/modules/debug-logger";
import Dialog from "src/components/Dialog";

import View from "./View";

const log = window.require("electron-log");

class EnterToken extends Component {
  state = {
    isLoading: false,
    invalidToken: false
  };

  handleActivationTokenSubmit = async (activationToken) => {
    const { setFlowState, flow, onRestoreFailure } = this.props;
    this.setState({ isLoading: true });
    try {
      const response = await verifyPaddleActivationToken(activationToken);
      debug.purchase("Received verifyPaddleActivationToken response", response);
      const { validity, email } = response;
      setFlowState({ email, activationToken });
      switch (validity) {
        case "valid":
          await this.tokenIsValidHandler();
          break;
        case "belongsToUser":
          flow.push("prefilled-login");
          break;
        case "invalid":
          this.setState({ invalidToken: true });
          break;
        default:
          throw new Error("Bad response");
      }
    } catch (error) {
      log.error(error);
      onRestoreFailure();
    }
  };
  tokenIsValidHandler = async () => {
    const { activationToken, email } = this.props.flowState;
    const { isAnonymousUser, applyPaddleActivationToken, flow } = this.props;

    if (isAnonymousUser) {
      debug.purchase(
        "Valid activation token, caching activation data to localStorage"
      );
      localStorage.setItem(
        "purchase.activationData",
        JSON.stringify({ email, activationToken })
      );
      flow.push("purchase-success");
      return;
    }

    await applyPaddleActivationToken(activationToken);
    flow.push("purchase-success");
  };
  dismissInvalidTokenDialog = () => {
    this.setState({ invalidToken: false, isLoading: false });
  };

  render() {
    const { isLoading, invalidToken } = this.state;
    const { onClose, flow, t, isRestore, initialStep, onBack } = this.props;

    return (
      <>
        <View
          onBack={
            initialStep === "enter-token"
              ? onBack
              : () => flow.push("buy", { direction: "previous" })
          }
          isLoading={isLoading}
          onClose={onClose}
          openHelp={() => flow.push("help")}
          onTokenSubmit={this.handleActivationTokenSubmit}
          isRestore={isRestore}
        />
        <Dialog
          isOpen={invalidToken}
          heading={t("purchase.wrongCode")}
          text={t("purchase.enterToken.invalidTokenDialog.text")}
          type="failure"
          buttons={[
            {
              onClick: this.dismissInvalidTokenDialog,
              text: t("buttons.ok")
            }
          ]}
        />
      </>
    );
  }
}

export default withTranslation()(EnterToken);
